import * as ActionTypes from './actionTypes'

export const NAME = 'map'

const initialState = {
  map: {},
  view: {},
  legendLayer: {},
  searchLayer: {},
  selectedParcels: []
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_MAP_AND_VIEW:
      return {
        ...state,
        map: { ...state.map, [action.id]: action.map },
        view: { ...state.view, [action.id]: action.view },
      }
    case ActionTypes.SET_LEGEND_LAYER:
      return {
        ...state,
        legendLayer: { ...state.legendLayer, [action.mapId]: action.layer }
      }
    case ActionTypes.SET_SEARCH_RESULTS_LAYER:
      return {
        ...state,
        searchLayer: { ...state.searchLayer, [action.mapId]: action.layer }
      }
    case ActionTypes.SET_SELECTED_PARCELS:
      return {
        ...state,
        selectedParcels: action.parcels
      }
    default:
      return state
  }
}

export default reducer